<template>
    <NavbarUnlogged v-if="!loggedIn" :show-search="showSearchUnlogged" />
    <NavbarLogged v-else />
</template>

<script setup lang="ts">
    import {NavbarStateResourceNavbarDisplayModeEnum} from '@navbar-api';
    import {storeToRefs} from 'pinia';
    import {NavbarLogged, NavbarUnlogged} from '#components';
    import {useAuth} from '#imports';
    import {useNavbarStateStore} from './logged/registry';

    const {showSearchUnlogged = false, isFunnelMode = false} = defineProps<{
        showSearchUnlogged?: boolean;
        isFunnelMode?: boolean;
    }>();

    const {loggedIn} = storeToRefs(useAuth());

    const navbarStateStore = useNavbarStateStore();
    if (isFunnelMode) {
        navbarStateStore.updateNavbarDisplayMode(NavbarStateResourceNavbarDisplayModeEnum.Funnel);
    }
</script>
